import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M18.707 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M5.293 5.293a1 1 0 0 1 1.414 0l12 12a1 1 0 0 1-1.414 1.414l-12-12a1 1 0 0 1 0-1.414'
      clipRule='evenodd'
    />
  </svg>
)
export default SvgComponent
